export default __webpack_public_path__ + "static/media/exit.4c9eca3d.svg";